/**
 * lucide-react v0.115.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const MailPlus = createLucideIcon("MailPlus", [
  [
    "path",
    {
      d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8",
      key: "12jkf8"
    }
  ],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);

export { MailPlus as default };
//# sourceMappingURL=mail-plus.js.map
